import { useMemo } from 'react';
import { useAppStore } from '../store/useAppStore';

/**
 * 把左侧全局「品牌 + 地区」选择映射为站内数据仓库 (Hologres) 的
 * business_shop_name。
 *
 * 站点 code 形如 `<region>-<brand>`（如 us-zeelool / ca-zeelool）。
 * Hologres 命名规则（实测）：
 *   - US 站点无后缀：Zeelool / Vooglam
 *   - 其他地区加小写后缀：Zeelool_ca / Zeelool_de / Zeelool_uk / Zeelool_fr
 *
 * 返回的 shopName 可直接作为站内报表接口的 site 参数。
 */
export function useSiteShopName(): { shopName: string; brand: string; region: string } {
  const brand = useAppStore((s) => s.brand);
  const site = useAppStore((s) => s.site);
  const sites = useAppStore((s) => s.sites);
  const siteId = useAppStore((s) => s.siteId);

  return useMemo(() => {
    // 当前站点 code：优先用 siteId 对应的 code，回退到 store.site
    const code = sites.find((s) => s.id === siteId)?.code ?? site ?? '';
    const parts = String(code).split('-');
    const region = (parts[0] || 'us').toLowerCase();
    // 品牌名：优先取 code 第二段，回退到 store.brand
    const brandSlug = (parts[1] || brand || 'zeelool').toLowerCase();

    const brandName = brandSlug.charAt(0).toUpperCase() + brandSlug.slice(1);
    const shopName = region === 'us' ? brandName : `${brandName}_${region}`;

    return { shopName, brand: brandName, region };
  }, [brand, site, sites, siteId]);
}
